import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi, NotificationConfig } from '@/lib/api';

export function useNotificationConfigs() {
  return useQuery({
    queryKey: ['notification-configs'],
    queryFn: () => notificationsApi.getConfigs(),
  });
}

export function useUpdateNotificationConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ event, ...data }: { event: string; channels?: Partial<NotificationConfig['channels']>; isActive?: boolean }) =>
      notificationsApi.updateConfig(event, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notification-configs'] });
    },
  });
}
